export const ANIMATION_DURATION = 140;
